import * as React from 'react';
import Box from '@amzn/awsui-components-console/box';
import SpaceBetween from '@amzn/awsui-components-console/space-between';

const HistoryTab: React.FC = () => {
  return (
    <Box margin={{ vertical: 'l' }} textAlign="center">
      <SpaceBetween size="m">
        <Box variant="h2" color="text-status-inactive">
          Coming soon
        </Box>
        <Box variant="p" color="text-status-inactive">
          Audit history and change logs will be displayed here.
        </Box>
      </SpaceBetween>
    </Box>
  );
};

export default HistoryTab;
